import styled, { css } from "styled-components";
import { Input as InputPrimitive } from "react-aria-components";
import { CoreTypography } from "@boi/components-core";
import { useDesignTokens, parseSizeToken } from "@boi/react-design-tokens";

export const SlotWrapper = styled.div`
  display: contents;
`;

export const Input = styled(InputPrimitive)`
  ${() => {
    const { tokens } = useDesignTokens();
    const { textInput, typography } = tokens;

    const typographyVariant: CoreTypography.Variant =
      textInput.typography.variant;

    const fontSize = parseSizeToken(typography.fontSize[typographyVariant]);
    const lineHeight = parseSizeToken(typography.lineHeight[typographyVariant]);

    return css`
      all: unset;
      width: 100%;
      color: ${textInput.color.base};
      font-family: ${typography.fontFamily[typographyVariant]};
      font-size: ${fontSize};
      line-height: ${lineHeight};

      &[data-readonly] {
        color: ${textInput.color.readOnly};
      }

      &[data-disabled] {
        color: ${textInput.color.disabled};
      }

      &::placeholder {
        color: ${textInput.color.placeholder};
      }
    `;
  }}
`;

export const CharactersCounterContainer = styled.div`
  ${() => {
    const { tokens } = useDesignTokens();
    const { spacing } = tokens;

    return css`
      width: 100%;
      display: grid;
      gap: ${spacing.s4};
    `;
  }}
`;
